import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuth, ProtectedRoute } from '@/auth'
import { useAuthenticatedApi } from '@/hooks/useAuthenticatedApi'
import { ScrollToTop, InstallPromptBanner } from '@/components/layout'
import { PushOptInBanner } from '@/components/notifications'
import {
  Home,
  Profile,
  ProfileSetup,
  Notifications,
  MyMatches,
  MyLeagues,
  GroupDetail,
  MyGroups,
  GroupAdmin,
  LeagueAdmin,
  LeagueView,
  InviteAccept,
  NotFound,
  Privacy,
  Terms,
} from '@/pages'

function AppContent() {
  const { isLoading, isAuthenticated } = useAuth()
  
  // Setup authenticated API client
  useAuthenticatedApi()
  
  // Show loading while Auth0 processes the callback (handles ?code= etc)
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/groups"
          element={
            <ProtectedRoute>
              <MyGroups />
            </ProtectedRoute>
          }
        />
        <Route path="/group/:id" element={<GroupDetail />} />
        <Route
          path="/group/:id/admin"
          element={
            <ProtectedRoute>
              <GroupAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/group/:groupId/admin/league/:leagueId"
          element={
            <ProtectedRoute>
              <LeagueAdmin />
            </ProtectedRoute>
          }
        />
        <Route path="/group/:groupId/league/:leagueId" element={<LeagueView />} />
        <Route
          path="/invite/:token"
          element={<InviteAccept />}
        />
        <Route
          path="/signup"
          element={
            <ProtectedRoute>
              <ProfileSetup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/matches"
          element={
            <ProtectedRoute>
              <MyMatches />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leagues"
          element={
            <ProtectedRoute>
              <MyLeagues />
            </ProtectedRoute>
          }
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      
      {/* Install prompt banner - shows after 30s on site if not installed */}
      <InstallPromptBanner />
      
      {/* Push notification opt-in banner - shows for authenticated users who haven't enabled push */}
      {isAuthenticated && <PushOptInBanner />}
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  )
}

export default App
